import { createFileRoute } from '@tanstack/react-router'
import { FeaturesPage } from '@/components/pages/features-page'

export const Route = createFileRoute('/features')({
  component: FeaturesPage,
  head: () => ({ meta: [{ title: 'Features — mkdn.app' }] }),
})
